import api from "./api";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export const loadOfferPartnerQuestionsKey = (documentId, siteId, partnerId) => {
  return `${documentId}-${siteId}-${partnerId}`;
};

export const loadOfferPartnerQuestionActionsKey = (documentId, siteId, partnerId) => {
  return `${documentId}-${siteId}-${partnerId}`;
};

export function loadOfferPartnerQuestions(documentId, siteId, partnerId, reload = false) {
  return async (dispatch, getState) => {
    let loadQuestionsKey = loadOfferPartnerQuestionsKey(documentId, siteId, partnerId);
    const offerPartnerQuestions = getState().offerPartnerQuestions;
    let shouldCallApi = reload || !offerPartnerQuestions || !offerPartnerQuestions[loadQuestionsKey].loaded;
    if (!shouldCallApi) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getOfferPartnerQuestions(documentId, siteId, partnerId)));
      dispatch({
        type: actionTypes.LOAD_OFFER_QUESTIONS_SUCCEEDED,
        key: loadQuestionsKey,
        payload: response
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferPartnerQuestionActions(documentId, siteId, partnerId, reload = false) {
  return async (dispatch, getState) => {
    let loadQuestionActionsKey = loadOfferPartnerQuestionActionsKey(documentId, siteId, partnerId);
    const offerPartnerQuestionActions = getState().offerPartnerQuestionActions;
    let shouldCallApi =
      reload || !offerPartnerQuestionActions || !offerPartnerQuestionActions[loadQuestionActionsKey].loaded;
    if (!shouldCallApi) {
      return;
    }

    try {
      const response = await dispatch(
        sendHttpRequest(api.getOfferPartnerQuestionActions(documentId, siteId, partnerId))
      );
      dispatch({
        type: actionTypes.LOAD_OFFER_QUESTIONACTIONS_SUCCEEDED,
        key: loadQuestionActionsKey,
        payload: response
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function addOrUpdateQuestionnaireId(data, callback = () => {}) {
  const { documentId, siteId, partnerId, questionnaireId } = data;
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.setQuestionnaire(documentId, siteId, partnerId, questionnaireId),
          "setQuestionnaireIdCommand",
          [eventTypes.PARTNER_QUESTIONNAIRE_UPDATED, eventTypes.PARTNER_QUESTIONNAIRE_NOT_FOUND]
        )
      );

      if (event.ok && event.eventBody.questionnaireId) {
        callback(event.eventBody.questionnaireId, event.eventBody.questionnaireName);
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function startQuestion(data, callback = () => {}) {
  const { documentId, siteId, partnerId, questionnaireId, startQuestionNo } = data;

  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.startQuestion(documentId, siteId, partnerId, questionnaireId, startQuestionNo),
          "startQuestionCommand",
          [eventTypes.PARTNER_QUESTIONNAIRE_NEXT_QUESTION_COMPLETED]
        )
      );

      if (event.ok) {
        callback(startQuestionNo, event.eventBody.question);
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function nextQuestion(data, callback = () => {}) {
  const { documentId, siteId, partnerId, questionnaireId, answeredQuestions, currentQuestion, startQuestionNo } = data;

  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.nextQuestion(documentId, siteId, partnerId, questionnaireId, answeredQuestions),
          "nextQuestionCommand",
          [eventTypes.PARTNER_QUESTIONNAIRE_NEXT_QUESTION_COMPLETED]
        )
      );

      if (event.ok) {
        if (startQuestionNo && startQuestionNo > 0) callback(startQuestionNo, event.eventBody.question);
        else callback(currentQuestion, event.eventBody.question);
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function finishQuestion(data, callback = () => {}) {
  const { documentId, siteId, partnerId, questionnaireId, answeredQuestions } = data;

  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.finishQuestionnaire(documentId, siteId, partnerId, questionnaireId, answeredQuestions),
          "finishQuestionCommand",
          [eventTypes.PARTNER_QUESTIONNAIRE_FINISH_COMPLETED]
        )
      );

      if (event.ok) {
        callback(documentId, siteId, partnerId, questionnaireId);
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
